import React from 'react';
import MapIcon from '../../assets/images/map.png';
import PhoneIcon from '../../assets/images/phone.png';
import EmailIcon from '../../assets/images/mail.png';

const ContactInfo = ({ contactInfo, openHours, contactDetails }) => {
    // Backward compatibility: render legacy content if new structure isn't provided
    if (!contactDetails) {
        return (
            <p className="text-gableGreen whitespace-pre-line font-mori text-base sm:text-lg leading-6 2xl:leading-8">
                {contactInfo}
                <br /><br />
                {openHours}
            </p>
        );
    }

    const {
        openHours: hours,
        openingHoursSchedule,
        christmasClosure,
        addressText,
        addressLink,
        consultantName,
        consultantTitle,
        phoneText,
        emailText,
        salesContacts
    } = contactDetails;

    return (
        <div className="text-gableGreen font-mori text-base sm:text-lg leading-none">
            {hours && (
                <p className="mb-2">Opening Hours: <span className="font-medium">{hours}</span></p>
            )}
            {!hours && Array.isArray(openingHoursSchedule) && openingHoursSchedule.length > 0 && (
                <div className="mb-2">
                    <p className="mb-0">Opening Hours:</p>
                    <ul className="list-disc ml-5 font-medium">
                        {openingHoursSchedule.map((item, idx) => (
                            <li key={idx}>{item.day}: {item.hours}</li>
                        ))}
                    </ul>
                </div>
            )}
            {christmasClosure && (
                <p className="mb-2">
                    Christmas Closure: <span className="font-medium">{christmasClosure}</span>
                </p>
            )}
            {(addressText || addressLink) && (
                <p className="mb-2">
                    <img src={MapIcon} alt="Map" className="inline-block w-4 h-4 mr-2 align-text-bottom text-gableGreen font-medium" />
                    {addressLink ? (
                        <a href={addressLink} target="_blank" rel="noopener noreferrer" className="text-gableGreen underline font-medium">
                            {addressText || 'View on map'}
                        </a>
                    ) : (
                        addressText
                    )}
                </p>
            )}
            {(consultantName || consultantTitle) && (
                <p className="mb-2 font-medium">
                    {consultantName}
                    {consultantTitle ? `, ${consultantTitle}` : ''}
                </p>
            )}
            {phoneText && (
                <p className="mb-2">
                    <img src={PhoneIcon} alt="Phone" className="inline-block w-4 h-4 mr-2 align-text-bottom text-gableGreen font-medium" />
                    <a href={`tel:${phoneText.replace(/\s+/g, '')}`} className="text-gableGreen underline font-medium">{phoneText}</a>
                </p>
            )}
            {emailText && (
                <p className="mb-2">
                    <img src={EmailIcon} alt="Email" className="inline-block w-4 h-4 mr-2 align-text-bottom text-gableGreen font-medium" />
                    <a href={`mailto:${emailText}`} className="text-gableGreen underline font-medium">{emailText}</a>
                </p>
            )}
            {Array.isArray(salesContacts) && salesContacts.length > 0 && (
                <div className="mt-2">
                    <p className="mb-1">Sales contacts:</p>
                    <ul className="list-disc ml-5 font-medium">
                        {salesContacts.map((sc, idx) => (
                            <li key={idx}>
                                {sc.name}{sc.email ? (
                                    <> <a href={`mailto:${sc.email}`} className="text-gableGreen underline font-medium">{sc.email}</a></>
                                ) : null}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default ContactInfo;